module.exports = __webpack_public_path__ + "img/color-companion-1_jp.681d21c.jpg";